import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useApp } from "@/contexts/AppContext";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Plus, ClipboardList } from "lucide-react";

const STATUS_STYLES = {
    free: "table-free",
    occupied: "table-occupied",
    billing: "table-billing",
};

export default function WaiterHome() {
    const { t, lang, user } = useApp();
    const navigate = useNavigate();
    const [tables, setTables] = useState([]);

    const load = async () => {
        const r = await api.get("/tables");
        setTables(r.data);
    };

    useEffect(() => {
        load();
        const i = setInterval(load, 5000);
        return () => clearInterval(i);
    }, []);

    return (
        <div className="space-y-5" data-testid="waiter-home">
            <div className="flex items-center justify-between">
                <div>
                    <div className="text-sm text-muted-foreground">{t("waiter")}</div>
                    <h1 className={`${lang === "ar" ? "font-ar" : "font-display-en italic"} text-3xl`}>{user?.name}</h1>
                </div>
                <Button asChild size="lg" className="h-14 px-6 text-base" data-testid="waiter-new-order-btn">
                    <Link to="/waiter/new"><Plus className="h-5 w-5 me-2" />{t("new_order")}</Link>
                </Button>
            </div>

            <Card className="grain bg-card/70">
                <CardContent className="p-5">
                    <div className="text-sm font-medium mb-3">{t("choose_table")}</div>
                    <div className="grid grid-cols-5 sm:grid-cols-7 md:grid-cols-10 gap-2">
                        {tables.map((tb) => (
                            <button
                                key={tb.id}
                                onClick={() => navigate(`/waiter/new?table=${tb.number}`)}
                                data-testid={`waiter-table-${tb.number}`}
                                className={`aspect-square rounded-xl border ${STATUS_STYLES[tb.status]} flex flex-col items-center justify-center active:scale-95 transition-all`}
                            >
                                <div className="text-lg font-medium tabular-nums">{tb.number}</div>
                                <div className="text-[9px] uppercase tracking-wider opacity-80">{t(tb.status)}</div>
                            </button>
                        ))}
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
